import { render, staticRenderFns } from "./InstantCreditOption.vue?vue&type=template&id=63068f12"
import script from "./InstantCreditOption.vue?vue&type=script&setup=true&lang=js"
export * from "./InstantCreditOption.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports